const ClickAllObjects = "Click All Objects";
const ClickAllObjectsAction = "Click_All_Object_Action";

export default ClickAllObjects;
export { ClickAllObjects, ClickAllObjectsAction };
